module.exports = __webpack_public_path__ + "images/sprites/ui/circle_arrow_og_96d1f05116f26075f1ce10721e0cdb52.png";